// extracted by mini-css-extract-plugin
export default {"container":"wCOECR","item":"UCfQqM"};